// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"f9aa344c","315":"f9aa344c","420":"f9aa344c","436":"15c20178","553":"f9aa344c"}[chunkId] + ".chunk.css";
};